export const mockDeals = [
  {
    id: 1,
    type: 'hotel',
    title: 'Luxury Resort & Spa',
    location: 'Maldives',
    originalPrice: 899,
    salePrice: 599,
    discount: 33,
    rating: 4.8,
    reviews: 1247,
    image: 'https://readdy.ai/api/search-image?query=luxury%20overwater%20bungalow%20resort%20in%20maldives%20with%20crystal%20clear%20turquoise%20water%2C%20white%20sand%20beach%2C%20palm%20trees%2C%20tropical%20paradise%20setting%2C%20modern%20minimalist%20architecture%2C%20bright%20sunny%20day%2C%20professional%20travel%20photography%20style&width=400&height=300&seq=1&orientation=landscape',
    features: ['Free WiFi', 'Pool', 'Spa', 'Beach Access']
  },
  {
    id: 2,
    type: 'flight',
    title: 'Round-trip to Paris',
    location: 'New York → Paris',
    originalPrice: 1299,
    salePrice: 899,
    discount: 31,
    airline: 'Air France',
    duration: '7h 30m',
    image: 'https://readdy.ai/api/search-image?query=modern%20commercial%20airplane%20flying%20above%20clouds%20with%20eiffel%20tower%20and%20paris%20cityscape%20visible%20below%2C%20golden%20sunset%20lighting%2C%20professional%20aviation%20photography%2C%20clean%20blue%20sky%20background&width=400&height=300&seq=2&orientation=landscape',
    features: ['Direct Flight', 'Meals Included', 'Entertainment']
  },
  {
    id: 3,
    type: 'package',
    title: 'Tokyo Adventure Package',
    location: 'Tokyo, Japan',
    originalPrice: 2499,
    salePrice: 1899,
    discount: 24,
    duration: '7 days',
    includes: 'Flight + Hotel + Tours',
    image: 'https://readdy.ai/api/search-image?query=tokyo%20skyline%20with%20mount%20fuji%20in%20background%2C%20cherry%20blossom%20trees%20in%20foreground%2C%20traditional%20japanese%20architecture%20mixed%20with%20modern%20skyscrapers%2C%20spring%20season%2C%20soft%20pink%20and%20blue%20color%20palette%2C%20travel%20destination%20photography&width=400&height=300&seq=3&orientation=landscape',
    features: ['5-Star Hotel', 'Guided Tours', 'Breakfast Included']
  },
  {
    id: 4,
    type: 'car',
    title: 'Premium Car Rental',
    location: 'Los Angeles',
    originalPrice: 89,
    salePrice: 59,
    discount: 34,
    carType: 'BMW 3 Series',
    duration: 'per day',
    image: 'https://readdy.ai/api/search-image?query=luxury%20bmw%20sedan%20parked%20on%20scenic%20california%20coastal%20highway%20with%20ocean%20view%2C%20palm%20trees%2C%20sunny%20weather%2C%20professional%20automotive%20photography%2C%20clean%20modern%20design%2C%20bright%20blue%20sky&width=400&height=300&seq=4&orientation=landscape',
    features: ['GPS Included', 'Full Insurance', 'Free Cancellation']
  }
];

export const mockDestinations = [
  {
    id: 1,
    name: 'New York City',
    country: 'United States',
    image: 'https://readdy.ai/api/search-image?query=new%20york%20city%20manhattan%20skyline%20with%20empire%20state%20building%20and%20skyscrapers%2C%20central%20park%20in%20foreground%2C%20golden%20hour%20lighting%2C%20urban%20landscape%20photography%2C%20iconic%20american%20cityscape&width=300&height=200&seq=5&orientation=landscape',
    hotels: 1247,
    avgPrice: 189
  },
  {
    id: 2,
    name: 'London',
    country: 'United Kingdom',
    image: 'https://readdy.ai/api/search-image?query=london%20big%20ben%20and%20houses%20of%20parliament%20with%20thames%20river%2C%20red%20double%20decker%20bus%2C%20classic%20british%20architecture%2C%20cloudy%20sky%2C%20european%20travel%20destination%20photography&width=300&height=200&seq=6&orientation=landscape',
    hotels: 892,
    avgPrice: 156
  },
  {
    id: 3,
    name: 'Tokyo',
    country: 'Japan',
    image: 'https://readdy.ai/api/search-image?query=tokyo%20shibuya%20crossing%20with%20neon%20signs%20and%20modern%20buildings%2C%20busy%20street%20scene%2C%20japanese%20urban%20culture%2C%20evening%20lighting%2C%20vibrant%20colors%2C%20asian%20travel%20destination%20photography&width=300&height=200&seq=7&orientation=landscape',
    hotels: 654,
    avgPrice: 134
  },
  {
    id: 4,
    name: 'Paris',
    country: 'France',
    image: 'https://readdy.ai/api/search-image?query=paris%20eiffel%20tower%20with%20seine%20river%20and%20classic%20haussmanian%20buildings%2C%20romantic%20european%20atmosphere%2C%20golden%20sunset%20lighting%2C%20french%20architecture%2C%20travel%20destination%20photography&width=300&height=200&seq=8&orientation=landscape',
    hotels: 1089,
    avgPrice: 178
  },
  {
    id: 5,
    name: 'Dubai',
    country: 'UAE',
    image: 'https://readdy.ai/api/search-image?query=dubai%20burj%20khalifa%20and%20modern%20skyscrapers%20with%20desert%20landscape%2C%20luxury%20middle%20eastern%20architecture%2C%20golden%20sand%20dunes%2C%20blue%20sky%2C%20futuristic%20cityscape%20photography&width=300&height=200&seq=9&orientation=landscape',
    hotels: 423,
    avgPrice: 245
  },
  {
    id: 6,
    name: 'Bali',
    country: 'Indonesia',
    image: 'https://readdy.ai/api/search-image?query=bali%20tropical%20beach%20with%20traditional%20balinese%20temple%2C%20palm%20trees%2C%20turquoise%20water%2C%20white%20sand%2C%20lush%20green%20rice%20terraces%20in%20background%2C%20peaceful%20island%20paradise%20photography&width=300&height=200&seq=10&orientation=landscape',
    hotels: 567,
    avgPrice: 98
  }
];

export const mockActivities = [
  {
    id: 1,
    title: 'Statue of Liberty & Ellis Island Tour',
    location: 'New York City',
    price: 45,
    duration: '4 hours',
    rating: 4.7,
    reviews: 2341,
    image: 'https://readdy.ai/api/search-image?query=statue%20of%20liberty%20on%20liberty%20island%20with%20new%20york%20harbor%2C%20ferry%20boat%20approaching%2C%20clear%20blue%20sky%2C%20american%20landmark%20photography%2C%20patriotic%20atmosphere&width=300&height=200&seq=11&orientation=landscape'
  },
  {
    id: 2,
    title: 'Eiffel Tower Skip-the-Line',
    location: 'Paris',
    price: 67,
    duration: '2 hours',
    rating: 4.9,
    reviews: 1876,
    image: 'https://readdy.ai/api/search-image?query=eiffel%20tower%20close%20up%20view%20from%20below%20with%20intricate%20iron%20structure%20details%2C%20tourists%20walking%20around%2C%20parisian%20atmosphere%2C%20architectural%20photography&width=300&height=200&seq=12&orientation=landscape'
  },
  {
    id: 3,
    title: 'Tokyo Food Walking Tour',
    location: 'Tokyo',
    price: 89,
    duration: '3 hours',
    rating: 4.8,
    reviews: 1234,
    image: 'https://readdy.ai/api/search-image?query=tokyo%20street%20food%20market%20with%20traditional%20japanese%20cuisine%2C%20sushi%2C%20ramen%2C%20colorful%20food%20stalls%2C%20local%20vendors%2C%20authentic%20culinary%20experience%20photography&width=300&height=200&seq=13&orientation=landscape'
  },
  {
    id: 4,
    title: 'Desert Safari Adventure',
    location: 'Dubai',
    price: 125,
    duration: '6 hours',
    rating: 4.6,
    reviews: 987,
    image: 'https://readdy.ai/api/search-image?query=dubai%20desert%20safari%20with%204x4%20vehicles%20on%20golden%20sand%20dunes%2C%20camel%20caravan%2C%20bedouin%20camp%2C%20sunset%20lighting%2C%20adventure%20tourism%20photography&width=300&height=200&seq=14&orientation=landscape'
  }
];